module.exports = __webpack_public_path__ + "img/img3.242fe2b8.svg";